import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import HeaderSection from '../comp/HeaderSection';
import KPISection from './KPISection';
import PieChartSection from './PieChartSection';
import ChartsSection from './ChartsSection';
import ChartsSection2 from './ChartsSection2';
import ModalDespesas from '../comp/ModalDespesas';

import { getResumoFinanceiro, getDatasEmAberto, getTotaisDespesas, getGraficosDespesas, getResumoDespesas } from '../../../api';

const PageContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Adjust as needed for responsiveness */
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Despesas = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [datasEmAberto, setDatasEmAberto] = useState({});
  const [dateToOpen2, setDateToOpen2] = useState(null);
  const [totaisDespesas, setTotaisDespesas] = useState({})
  const [graficosDespesas, setGraficoDespesas] = useState({})
  const [despesas, setDespesas] = useState({});
  
    // Filtro ----
    const dataAtual = new Date();
    const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
    const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
    const emptyFiltro = {
      datainicial: primeiroDiaDoMes,
      datafinal: ultimoDiaDoMes,
    };
    const [filtro, setFiltro] = useState({ ...emptyFiltro });

  useEffect(() => {
    fetchData();
  }, [filtro]);

  const fetchData = async () => {
    try {
      const result = await getResumoFinanceiro();
      const result2 = await getDatasEmAberto(filtro);
      const result3 = await getTotaisDespesas(filtro)
      const result4 = await getGraficosDespesas(filtro)
      const result5 = await getResumoDespesas(filtro);
      setData(result);
      setDatasEmAberto(result2);
      setTotaisDespesas(result3);
      setGraficoDespesas(result4)
      setDespesas(result5)
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = async () => {
    setDateToOpen2(null);
    const result = await getDatasEmAberto();
    setDatasEmAberto(result);
  };

  const onDoubleClick2 = (dateClicked) => {
    setDateToOpen2(dateClicked);
  };

  if (loading) {
    return <p>Carregando gráfico...</p>;
  }

  return (
    <PageContainer>
      <HeaderSection title={'Despesas'} setFiltro={setFiltro} filtro={filtro}/>
      <ChartsSection data={data} />
      <ChartsSection2 data={despesas} receivableDates={datasEmAberto.aPagar} onDoubleClick={onDoubleClick2} />

      
      <KPISection totaisDespesas={totaisDespesas}/>
      <PieChartSection graficosDespesas={graficosDespesas}/>
      
      {dateToOpen2 && <ModalDespesas dateToOpen={dateToOpen2} onClose={handleClose} />}
    </PageContainer>
  );
};

export default Despesas;
